import React, { useEffect, useState } from 'react'
import '../css/ContactMe.css'
import GitHubIcon from '@material-ui/icons/GitHub';
import InstagramIcon from '@material-ui/icons/Instagram';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import EmailIcon from '@material-ui/icons/Email';
import gsap from 'gsap/gsap-core';
import { Bounce } from 'gsap/gsap-core';
import axios from 'axios';
import $ from 'jquery'
import 'react-toastify/dist/ReactToastify.css';
import ReactLoading from 'react-loading';
import { toast, ToastContainer } from 'react-toastify';

function ContactMe({ setPathName }) {
    setPathName(window.location.pathname)
    useEffect(() => {
        gsap.from('.contact h1', { y: -200, duration: 1.2, ease: Bounce.easeOut, opacity: 0 })
        gsap.from('.contact-form p', { x: '-50%', duration: 1.2, opacity: 0 })

    }, [])
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [subject, setSubject] = useState('')
    const [message, setMessage] = useState('')
    const onNameChange = (e) => {
        setName(e.target.value)
    }
    const onEmailChange = (e) => {
        setEmail(e.target.value)
    }
    const onSubjectChange = (e) => {
        setSubject(e.target.value)
    }
    const onMessageChange = (e) => {
        setMessage(e.target.value)
    }
    const showError = () => {
        toast.error('Please fill all required fields!', {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
        showBorderRed($('#name')[0])
        showBorderRed($('#email')[0])
        showBorderRed($('#message')[0])
    }
    const checkForm = () => {
        if ((!email.includes('@')) || (!email.includes('.')) || (email.includes('@.'))) {
            showError()
        }
        else {
            sendEmail()
        }
    }
    const sendEmail = () => {
        $('#loading,#loadingScreen').css({ display: 'block' })
        $('.homenav *').siblings().css({ opacity: 0.6 })

        axios({
            method: "POST",
            url: "https://shakthi-portfolio-server.herokuapp.com/send",
            data: { name: name, email: email, subject: subject, message: message }
        }).then((response) => {
            if (response.data.status === 'success') {
                $('#loading,#loadingScreen').css({ display: 'none' })
                $('.homenav *').siblings().css({ opacity: 1 })
                toast.success('Successfully Sent!', {
                    position: 'bottom-right',
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                })
                resetForm()
            } else if (response.data.status === 'fail') {
                toast.error('Something went wrong!', {
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                })
            }
        })
    }
    function resetForm() {
        setName('');
        setEmail('');
        setSubject('');
        setMessage('');
    }
    function showBorderRed(prop) {
        if (prop.value === '') {
            $(`.${prop.name}`).addClass('toggleClass')
        }
        else if (prop.name === 'email') {
            if ((!email.includes('@')) || (!email.includes('.')) || (email.includes('@.'))) {
                $(`.${prop.name}`).addClass('toggleClass')
            }
            else {
                $(`.${prop.name}`).removeClass('toggleClass')
            }
        }
        else {
            $(`.${prop.name}`).removeClass('toggleClass')
        }
    }
    return (
        <div className='contact'>
            <ToastContainer />
            <div id='loadingScreen'>
                <ReactLoading id='loading' type={'bars'} color={'#08fdd8'} height={100} width={100} />
            </div>
            <div className='contact-left'>
                <h1>Contact Me</h1>
                <div className='contact-form'>
                    <p>I'd love to hear from you. Drop me a line!</p>
                    <span className='name-email'>
                        <div className='border-container'>
                            <input type='txt' placeholder='Name' value={name} name='name' id='name'
                                onChange={(e) => onNameChange(e)}
                                onBlur={(e) => showBorderRed(e.target)}
                            ></input>
                            <span class="name"></span>
                        </div>
                        <div className='border-container'>
                            <input type='txt' placeholder='Email' value={email} name='email' id='email'
                                onChange={(e) => onEmailChange(e)}
                                onBlur={(e) => showBorderRed(e.target)}></input>
                            <span class="email"></span>
                        </div>
                    </span>
                    <div className='border-container'>
                        <input type='txt' placeholder='Subject' value={subject} onChange={(e) => onSubjectChange(e)}></input>
                        <span class="subject"></span>
                    </div>
                    <div className='border-container'>
                        <textarea type='textarea' rows="5" placeholder='Message' value={message}
                            name='message'
                            id='message'
                            onChange={(e) => onMessageChange(e)}
                            onBlur={(e) => showBorderRed(e.target)}></textarea>
                        <span class="message"></span>
                    </div>
                    <button onClick={checkForm}>SEND</button>
                </div>

            </div >
            <div className='contact-right'>
                <div className='location-email'>
                    <div className='location'>
                        <LocationOnIcon />
                        <p>Aruppukottai, Virudhunagar, TamilNadu, India</p>
                    </div>
                    <div className='contact-email'>
                        <EmailIcon />
                        <p>shakthi012000@gmail.com</p>
                    </div>
                </div>
                <div className='social-links'>
                    <p>I'm social!</p>
                    <div>
                        <a href='https://github.com/ShakthiGanesh' target='_blank'>
                            <GitHubIcon />
                        </a>
                        <a href='https://www.linkedin.com/in/shakthi-ganesh-r-32b4391b5' target='_blank'>
                            <LinkedInIcon />
                        </a>
                        <a href='https://instagram.com/shakthi_harsha1?igshid=1sd9ypetejb0y' target='_blank'>
                            <InstagramIcon />
                        </a>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default ContactMe
